import React, { Component } from 'react'
import { css } from 'emotion'
import { NavbarView } from 'components'
import { MEDIA_QUERY } from 'styles'
import { LocationSelect, Logo } from 'cf-web-app/components'

class PageHeader extends Component {
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.innerContainer}>
          <div className={styles.location}>
            <Logo />
            <LocationSelect />
          </div>
          <NavbarView />
        </div>
      </div>
    )
  }
}

const styles = {
  container: css({
    margin: '0 auto',
    maxWidth: '160rem',
    width: '100%',
    height: '9rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#730008',
    boxShadow: '0 .2rem .4rem rgba(0,0,0,0.7)',
    [MEDIA_QUERY.SM]: {
      height: '13rem',
    },
  }),
  innerContainer: css({
    width: '90%',
    height: '100%',
    maxWidth: '120rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [MEDIA_QUERY.SM]: {
      paddingTop: '1rem',
      flexDirection: 'column',
      height: '13rem',
    },
  }),
  location: css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
}

export default PageHeader
